namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class IdExtFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.item.ChId == "19") {
                if (ctx.value == "" || ctx.value == null) {
                    return "";
                } else {
                    return `<span><a title="Send Email" style="cursor:pointer; margin-right:3px;" href="mailto:${ctx.value}">${ctx.value}</a></span>`;
                }
            } else if (ctx.item.ChId == "1" || !Q.isEmptyOrNull(ctx.item.Form) ){
                if (ctx.value == "" || ctx.value == null) {
                    return "";
                } else {
                    var fisrtLater = ctx.value.charAt(0);
                    var noHp = ctx.value;
                    var noHpFinal = ctx.value;
                    if (fisrtLater == "0") {
                        noHpFinal = '62' + noHp.substring(1);
                    }
                    //return `<span><a title="Telephone" style="cursor:pointer; margin-right:3px;"  href="tel:${Q.htmlEncode(ctx.value)}">${ctx.value}</a><a title="Send WhatsApp Messages" style="cursor:pointer;" onclick="window.open('https://wa.me/${noHpFinal}')"><i class='fab fa-whatsapp text-success'></i></a></span>`;
                    return `<span><a title="Telephone" style="cursor:pointer; margin-right:3px;"  href="tel:${Q.htmlEncode(ctx.value)}">${ctx.value}</a><a title="Send WhatsApp Messages" style="cursor:pointer;" onclick="window.open('/Services/Chat/Chatrooms/GetRoomId?extid=${noHpFinal}')"><i class='fab fa-whatsapp text-success'></i></a></span>`;
                }
            } else if (ctx.item.ChId == "2") {
                if (ctx.value == "" || ctx.value == null) {
                    return "";
                } else {
                    var fisrtLater = ctx.value.charAt(0);
                    var noHp = ctx.value;
                    var noHpFinal = ctx.value;
                    if (fisrtLater == "@") {
                        noHpFinal = noHp.substring(1);
                    }
                    return `<span><a title="Send Telegram Messages" onclick="window.open('https://t.me/${noHpFinal}')" href="#" style="cursor:pointer; margin-right:3px;">${ctx.value} <i class='fab fa-telegram text-primary'></i></a></span>`;
                }
            } else {
                return `<span><a title="Belum ada aksi" style="cursor:pointer; margin-right:3px;">${ctx.value}</a></span>`;
            }
        }
    }
}